// Mirrors GolfPlayed.Domain.Helpers.Constants.BillingFrequencyConstants on the backend.
// BillingFrequency is a seeded lookup table with no housekeeping screen of its own,
// so the fixed ids/labels are kept in sync here rather than fetched from an API.

export const BillingFrequencyConstants = {
  MONTHLY_ID: 'f2a1b3c4-1111-4a5b-9c0d-1e2f3a4b5c6d',
  ANNUALLY_ID: 'f2a1b3c4-2222-4a5b-9c0d-1e2f3a4b5c6d',
};

export const BILLING_FREQUENCY_OPTIONS = [
  { value: BillingFrequencyConstants.MONTHLY_ID, label: 'Monthly' },
  { value: BillingFrequencyConstants.ANNUALLY_ID, label: 'Annually' },
];
